import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doFindWebId } from '../../store/find.slice';
import { RootState } from '../../store/rootReducer';

import { useSnackbar } from 'notistack';

import Spinner from '../Spinner';
import Button from '../Button';
import { errorVariant, infoVariant, warningVariant } from '../../lib/barVariant';
import { setMemberName, setWebId } from '../../store/verify.slice';

interface IProps {
  handleNextPage: any;
}


const VerifyMember: FC<IProps> = ({ 
  handleNextPage
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();
  
  const { data, isLoading } = useSelector((state: RootState) => state.verify);
  const { webId, memberName } = data;
  
  const [isDisabled1, setIsDisabled1] = useState(false);
  const [isDisabled2, setIsDisabled2] = useState(false);
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const checkNullFindPw = () => {
    if (!webId || webId === '') {
      return t('auth.findPassword.message10');
    }
    if (!memberName || memberName === '') {
      return t('auth.findPassword.message11');
    }
    return false;
  }

  const onFindMember = async () => {
    const checkNullMessage = checkNullFindPw();

    if(checkNullMessage) {
      return enqueueSnackbar(checkNullMessage, infoVariant);
    }

    const res = await dispatch(
      doFindWebId({
        webId,
        memberName,
        memberType: 'E'
      }));

    switch (res?.status) {
      case 200:
        setIsDisabled2(true);
        handleNextPage();
        break;
      case 400:
        enqueueSnackbar(t('auth.verify.message3'), infoVariant);
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <div className="bx-row">
        <div className="bx-input">
          <input type="text"
                 placeholder={t('auth.findPassword.placeholder1')}
                 disabled={isDisabled1}
                 value={webId}
                 onChange={e => dispatch(setWebId(e.target.value))}
          />
        </div>
      </div>
      <div className="bx-row">
        <div className="bx-input">
          <input type="text"
                 placeholder={t('cbt.test.placeholder2')}
                 disabled={isDisabled1}
                 value={memberName}
                 onChange={e => dispatch(setMemberName(e.target.value))}
          />
        </div>
      </div>
      <div className="btn-area">
        <button type="button"
                className="btn-basic pink"
                onClick={onFindMember}
        >
          {t('common.button.next')}
        </button>
      </div>
    </>
  )
}

export default VerifyMember;
